import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_next-more",
  "use": "asus_proart_sw_ico_next-more-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_next-more\"><g id=\"asus_proart_sw_ico_next-more_asus_proart_sw_ico_arrow_next_page\"><rect width=\"48\" height=\"48\" fill=\"none\" /><path d=\"M32.71,24.71l-16,16-1.42-1.42L30.59,24,15.29,8.71l1.42-1.42,16,16A1,1,0,0,1,32.71,24.71Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol